import {ErrorHandler, Injectable} from '@angular/core';
import {commonErrorMessages} from '../constants/constants';
import {ClHeaderComponent} from '@mitel/cloudlink-console-components';
import {SpinnerService} from '../services/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorsHandlerService {

  constructor(
  	private clHeader: ClHeaderComponent,
	  private spinnerService: SpinnerService,
  ) { }

	handleError(error: any): void {
		console.error("handleError: ", error);
		if (error.statusCode) {
		  switch (error.statusCode) {
        case 404: {
          console.log('Function: handleError: ', "Not found");
          break;
        }
        case 403:
        case 401: {
	        console.log('Function: handleError: ', "Unauthorized");
	        this.clHeader.logoutUser();
	        break;
        }
		  }
    }

		if (error instanceof Error) {
		  console.log('Function: handleError, : ', 'instance of Error');
			if (error.message === commonErrorMessages.AUTH_ERROR) {
				this.clHeader.logoutUser();
			}
		}

	}


}
